module.exports = __webpack_public_path__ + "resources/img/img_i_onenet2.6e902744a1895e0f983a60c508d18908.png";